class CharmBuilder extends VariantPickers {
  constructor() {
    super();

    this.handleCharmQuantityChange = this.handleCharmQuantityChange.bind(this);

    this.lastCharmSelection = [];

    this.form = this.querySelector("form");
    this.quantity = 1;

    this.form.addEventListener("submit", this.handleSubmit.bind(this));

    this.updatePrice();
  }

  // Noop since this isn't a typical variant picker
  onVariantChange() {}
  updateContent() {}

  getSelectedBaseVariant() {
    const selectedBaseVariant = this.querySelector(
      ".product-option-picker__product-link-radio:checked"
    );
    return selectedBaseVariant && selectedBaseVariant.value
      ? parseInt(selectedBaseVariant.value)
      : undefined;
  }

  updateOptions() {
    const selectedBaseProduct = this.querySelector(
      ".product-option-picker__product-link-radio:checked"
    );
    if (selectedBaseProduct) {
      this.dataset.product = selectedBaseProduct.dataset.product || "";
    }

    super.updateOptions();
  }

  updateBuilderContent() {
    this.updateOptions();
    this.updateOptionLabels();
    this.updatePrice();
    this.updateProductRestrictedContent();
  }

  handleProductPickerLinkClick(event, target) {
    this.dataset.product = target.dataset.product || "";

    this.updateBuilderContent();

    if (target.dataset.removeProductMedia) {
      this.removeProductMedia();
    }

    const targetTagName = target.tagName.toLowerCase();
    const selectedLinkEl =
      targetTagName === "select"
        ? target.options[target.selectedIndex]
        : target;

    const selectedProductLink = selectedLinkEl.dataset.href;
    this.selectedProductLink = selectedProductLink;

    if (!selectedProductLink) {
      return;
    }

    const requestedProductLink = this.selectedProductLink;
    const selectedProductRenderLink = `${this.selectedProductLink}${
      this.selectedProductLink.indexOf("?") === -1 ? "?" : "&"
    }section_id=${this.dataset.section}`;

    window.history.pushState({}, "", this.selectedProductLink);

    this.toggleAddButton(true);

    fetch(selectedProductRenderLink)
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (requestedProductLink !== this.selectedProductLink) {
          return;
        }

        const sectionContainer = document.getElementById(
          `shopify-section-${this.dataset.section}`
        );
        const html = new DOMParser().parseFromString(responseText, "text/html");

        this.updateMedia(html, sectionContainer);

        const sourceAtc = html.querySelector(".js-add-to-cart");
        const destAtc = this.querySelector(".js-add-to-cart");
        if (sourceAtc && destAtc) {
          destAtc.replaceWith(sourceAtc);
        }

        const sourceBuilder = html.querySelector("charm-builder");

        if (sourceBuilder) {
          this.setAttribute("data-url", sourceBuilder.getAttribute("data-url"));
          this.setAttribute(
            "data-product",
            sourceBuilder.getAttribute("data-product")
          );
        }

        this.updateBuilderContent();
      })
      .catch((_err) => {
        if (requestedProductLink === this.selectedProductLink) {
          window.location.href = this.selectedProductLink;
        }
        this.toggleAddButton(false);
      });

    return false;
  }

  removeProductMedia() {
    let shouldRefresh = false;
    const sectionContainer = document.getElementById(
      `shopify-section-${this.dataset.section}`
    );

    const mediaListSources = [
      sectionContainer.querySelector(".embla-thumbs__container"),
      document.querySelector(`[id^="ProductModal-${this.dataset.section}"]`),
      sectionContainer.querySelector(".embla__container"),
    ];

    mediaListSources.forEach((source) => {
      if (!source) {
        return;
      }
      const items = Array.from(source.querySelectorAll("li[data-media-id]"));

      items.forEach((item) => {
        if (item.dataset.productId) {
          shouldRefresh = true;

          item.remove();
        }
      });
    });

    if (shouldRefresh) {
      const mediaGallerySource = sectionContainer.querySelector(
        `[id^="MediaGallery-${this.dataset.section}"]`
      );
      mediaGallerySource.reInit(0);
    }
  }

  connectedCallback() {
    const quantityOptions = this.querySelectorAll(
      'input[name="charm_quantity"]'
    );
    quantityOptions.forEach((option) => {
      option.addEventListener("change", this.handleCharmQuantityChange);
    });
  }

  formatPrice(price) {
    return new Intl.NumberFormat(window.currency.locale, {
      style: "currency",
      currency: window.currency.isoCode,
      currencyDisplay: "narrowSymbol",
      trailingZeroDisplay: "stripIfInteger",
    }).format(price);
  }

  updatePrice() {
    const addToCart = this.querySelector(".js-add-to-cart");
    const baseVariantId = this.getSelectedBaseVariant();
    let baseVariant;
    if (baseVariantId) {
      this.getProductData().base_products.find((product) =>
        product.variants.find((v) => {
          if (v.id === baseVariantId) {
            baseVariant = v;
            return true;
          }
        })
      );
    }
    const charmTiers = addToCart.dataset.charmTiers.split(",").map((t) => {
      const split = t.split(":");
      return {
        quantity: parseInt(split[0]),
        discountFactor: parseFloat(split[1]),
      };
    });
    const chainPrice = baseVariant ? baseVariant.price * 0.01 : 0;
    const chainComparePrice =
      baseVariant && baseVariant.compare_at_price
        ? baseVariant.compare_at_price * 0.01
        : 0;
    const charmPrice = parseFloat(addToCart.dataset.charmPrice) * 0.01;

    const tier = charmTiers.find((tier) => tier.quantity === this.quantity);
    const discountFactor = (tier && tier.discountFactor) || 1;
    const price = chainPrice + this.quantity * charmPrice * discountFactor;
    const comparePrice = chainComparePrice + this.quantity * charmPrice;

    addToCart.querySelector(".js-compare-price").textContent =
      this.formatPrice(comparePrice);
    addToCart.querySelector(".js-price").textContent = this.formatPrice(price);

    const startingPriceEl = this.productContainer.querySelector(
      ".js-charm-builder-starting-price"
    );
    if (startingPriceEl) {
      const singleCharmTier = charmTiers.find((tier) => tier.quantity === 1);
      let singleCharmPrice = charmPrice;
      if (singleCharmTier) {
        singleCharmPrice *=
          (singleCharmTier && singleCharmTier.discountFactor) || 1;
      }
      const startingPrice =
        (baseVariant ? baseVariant.price * 0.01 : 0) + singleCharmPrice;
      startingPriceEl.textContent = `Starting at ${this.formatPrice(
        startingPrice
      )}`;
    }
  }

  handleCharmQuantityChange(e) {
    const quantity = parseInt(e.target.value) || 1;
    this.quantity = quantity;
    const list = this.querySelector(".js-charm-items");
    const charmItems = Array.from(this.querySelectorAll(".js-charm-item"));
    charmItems.forEach((item, index) => {
      const value = item.querySelector("select").value;
      if (value) {
        this.lastCharmSelection[index] = value;
      }
    });
    while (charmItems.length > quantity) {
      const removeCharm = charmItems.pop();
      this.lastCharmSelection[charmItems.length] =
        removeCharm.querySelector("select").value;
      removeCharm.remove();
    }

    if (charmItems.length < quantity) {
      while (charmItems.length < quantity) {
        const clone = charmItems[0].cloneNode(true);
        clone.querySelector("select").value =
          this.lastCharmSelection[charmItems.length] || "";

        charmItems.push(clone);
        const label = clone.querySelector(".js-charm-item-label");
        label.textContent =
          label.textContent.split("#")[0] + "#" + charmItems.length;
        list.appendChild(clone);
      }
    }

    list.style.setProperty("--charm-count", quantity);
    this.updatePrice();
  }

  handleSubmit(e) {
    e.preventDefault();

    const submitButton = this.form.querySelector('button[type="submit"]');

    if (submitButton) {
      if (submitButton.getAttribute("aria-disabled") === "true") return;

      submitButton.setAttribute("aria-disabled", true);
      submitButton.classList.add("loading");
    }

    const items = [];
    const formData = new FormData(this.form);

    const chainProductId = formData.get("base_product");

    const charmIds = formData.getAll("charm");

    if (chainProductId) {
      items.push({
        quantity: 1,
        id: chainProductId,
      });
    }
    if (charmIds.length) {
      charmIds.forEach((id) => {
        if (id) {
          items.push({
            quantity: 1,
            id,
          });
        }
      });
    }

    window.BIRTHDATE_CART.addItemsToCart(
      {
        items,
      },
      {
        suppressAddedItemsEvent: false,
      }
    ).finally(() => {
      if (submitButton) {
        setTimeout(() => {
          submitButton.removeAttribute("aria-disabled");
          submitButton.classList.remove("loading");
        }, 10);
      }
    });
  }
}
customElements.define("charm-builder", CharmBuilder);
